import { render, staticRenderFns } from "./TaskInProgress.vue?vue&type=template&id=bb6d2fb6&scoped=true&"
import script from "./TaskInProgress.vue?vue&type=script&lang=ts&"
export * from "./TaskInProgress.vue?vue&type=script&lang=ts&"
import style0 from "./TaskInProgress.vue?vue&type=style&index=0&id=bb6d2fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6d2fb6",
  null
  
)

export default component.exports